import { useEffect, useState } from 'react'
import { useWindowSize } from 'react-use'

export const useBreakpoints = () => {
  const { width } = useWindowSize()
  const [isSm, setIsSm] = useState(true)
  const [isMd, setIsMd] = useState(true)
  const [isLg, setIsLg] = useState(true)
  const [isXl, setIsXl] = useState(true)

  useEffect(() => {
    setIsSm(width >= 576)
    setIsMd(width >= 768)
    setIsLg(width >= 992)
    setIsXl(width >= 1200)
  }, [width])

  return { isLg, isMd, isSm, isXl }
}
